module.exports = __webpack_public_path__ + "img/3.9cf5dfcc.jpeg";